import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema, getColumnQuery } from '@blaze-shared/schema-domain';
import { SelectColumnsWorkflowNode } from '@blaze-shared/workflow-domain';

import { COLUMN_SOURCE_ID, NODE_SOURCE_ID } from '../../errors/source-ids';
import { WorkflowError } from '../../errors/workflow-error';
import { getColumnReferencesFromInput1 } from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('SelectColumns')
export class SelectColumnsNode extends BaseWorkflowNode<SelectColumnsWorkflowNode> {
  static readonly NODE_SOURCE_ID = NODE_SOURCE_ID;
  static readonly ERROR_VALUE_SOURCE_ID = COLUMN_SOURCE_ID;

  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    const columns = this.node.columns.map((col) => getColumnQuery(col.column));

    return getColumnReferencesFromInput1(
      columns,
      schemas,
      SelectColumnsNode.ERROR_VALUE_SOURCE_ID,
      false,
    );
  }

  getTagReferences(_schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [];
  }

  getParamReferences(
    _schemas: Map<string | symbol, BaseSchema>,
    _connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [];
  }

  getNamedInputReferences(
    _schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [];
  }

  override validate(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowError<any>[] {
    const errors = super.validate(schemas, connectors);
    return errors;
  }
}
